import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const StudentDetails = ({
  student,
  completeProfile,
  handlePrint,
  setcompleteProfile,
}) => {
  const PayChalan = () => {
    if (
      student.academic_level === null ||
      student.category === null ||
      student.course_name === null ||
      student.course_year === null ||
      student.profile_photo === "0"
    ) {
      return "Complete Profile";
    } else {
      return "Edit profile";
    }
  };

  const [paymentStatus, setpaymentStatus] = useState("");
  const [texn, settxn] = useState("");

  useEffect(() => {
    if (
      !student ||
      !Array.isArray(student.transactions) ||
      student.transactions.length === 0
    ) {
      setpaymentStatus("Pending");
    } else {
      const filtered = student.transactions.filter(
        (t) => t.amount == 50 && String(t.status).toLowerCase() === "success"
      );
      setpaymentStatus(
        filtered.length > 0 ? filtered[filtered.length - 1] : "Pending"
      );
    }
  }, [student]);

  const FormStatus = localStorage.getItem("paymentStatus");

  const status = () => {
    switch (student.status) {
      case 1:
        return "Approved";
      case 2:
        return "Reject";
      default:
        return "Pending";
    }
  };

  return (
    <div>
      <div className="main-dashboard-card">
        <div className="main-dashboard-card-header main-dashboard-helpdesk-header">
          <div onClick={() => console.log(paymentStatus)}>
            <h2 className="main-dashboard-card-title">Student Details</h2>
          </div>
          {student.status === 1 ? (
            " "
          ) : (
            <button
              onClick={() => setcompleteProfile(!completeProfile)}
              className="main-dashboard-button"
            >
              {PayChalan()}
            </button>
          )}

          {paymentStatus.status === "success" && (
            <a
              target="_blank"
              href={`https://gdclalitpur.ac.in/chalan-receipt/print/${paymentStatus.txnid}`}
              // onClick={handlePrint}
              className="main-dashboard-button"
            >
              Print Chalan
            </a>
          )}
        </div>
        <div className="main-dashboard-card-body">
          <div className="main-dashboard-list-header">
            <span className="main-dashboard-list-header-label">
              Student Name:
            </span>
            <span className="main-dashboard-list-header-label">
              {student.name}
            </span>
          </div>

          <div className="main-dashboard-list-header">
            <span className="main-dashboard-list-header-label">Gender:</span>
            <span className="main-dashboard-list-header-label">
              {student.gender === "F"
                ? "Female"
                : student.gender === "M"
                ? "Male"
                : student.gender === "O" && "Other"}
            </span>
          </div>

          <div className="main-dashboard-list-header">
            <span className="main-dashboard-list-header-label">Category:</span>
            <span className="main-dashboard-list-header-label">
              {student.category}
            </span>
          </div>
          <div className="main-dashboard-list-header">
            <span className="main-dashboard-list-header-label">Email:</span>
            <span className="main-dashboard-list-header-label">
              {student.email}
            </span>
          </div>
          <div className="main-dashboard-list-header">
            <span className="main-dashboard-list-header-label">Phone:</span>
            <span className="main-dashboard-list-header-label">
              {student.phone_number}
            </span>
          </div>
          <div className="main-dashboard-list-header">
            <span className="main-dashboard-list-header-label">Course:</span>
            <span className="main-dashboard-list-header-label">
              {student.course_name === "" ? "NA" : student.course_name}
            </span>
          </div>

          <div className="main-dashboard-list-header">
            <span className="main-dashboard-list-header-label">
              Academic Level:
            </span>
            <span className="main-dashboard-list-header-label">
              {student.academic_level === "" ? "NA" : student.academic_level}
            </span>
          </div>
          <div className="main-dashboard-list-header">
            <span className="main-dashboard-list-header-label">
              Chalan Payment Status:
            </span>
            <span className="main-dashboard-list-header-label">
              {paymentStatus.status === "success" ? "Success" : "Pending"}
            </span>
          </div>

          <div className="main-dashboard-list-header">
            <span className="main-dashboard-list-header-label">
              Admission Form Status:
            </span>
            <span className="main-dashboard-list-header-label">{status()}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StudentDetails;
